import React from 'react'
import moment from 'moment'

const MONTHS = [
  'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni',
  'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'
]

const YEARS_BACK = 5

/**
 * US-DB-1 — the LOCAL period filter of the SLA Performance section
 * (Yearly / Monthly only). It lives inside the section so its limited scope
 * is obvious; no other section reacts to it (AC-1/AC-2).
 *
 * `resolveSlaPeriod` turns the filter into the {start, end} the SLA
 * endpoints expect. Yearly of the CURRENT year is YTD (ends today).
 */
export const resolveSlaPeriod = (filter) => {
  const today = moment()
  if (filter.mode === 'monthly') {
    const base = moment(`${filter.year}-${String(filter.month + 1).padStart(2, '0')}-01`, 'YYYY-MM-DD')
    const end = base.clone().endOf('month')
    return {
      start: base.format('YYYY-MM-DD'),
      end: (end.isAfter(today) ? today : end).format('YYYY-MM-DD')
    }
  }
  const end = filter.year === today.year()
    ? today
    : moment(`${filter.year}-12-31`, 'YYYY-MM-DD')
  return { start: `${filter.year}-01-01`, end: end.format('YYYY-MM-DD') }
}

export default class SlaFilterBar extends React.Component {
  change (patch) {
    this.props.onChange({ ...this.props.filter, ...patch })
  }

  render () {
    const { filter } = this.props
    const currentYear = moment().year()
    const years = []
    for (let y = currentYear; y > currentYear - YEARS_BACK; y--) {
      years.push(y)
    }

    return (
      <div className='dbv2-sla-filter'>
        <label>Periode:</label>
        <select
          value={filter.mode}
          onChange={(e) => this.change({ mode: e.target.value })}
        >
          <option value='yearly'>Yearly</option>
          <option value='monthly'>Monthly</option>
        </select>
        <select
          value={filter.year}
          onChange={(e) => this.change({ year: Number(e.target.value) })}
        >
          {years.map((y) => <option key={y} value={y}>{y}</option>)}
        </select>
        { filter.mode === 'monthly' &&
          <select
            value={filter.month}
            onChange={(e) => this.change({ month: Number(e.target.value) })}
          >
            {MONTHS.map((label, index) => (
              <option key={label} value={index}>{label}</option>
            ))}
          </select>
        }
      </div>
    )
  }
}
